import script from "./QModalVideos.vue?vue&type=script&setup=true&lang=js"
export * from "./QModalVideos.vue?vue&type=script&setup=true&lang=js"

import "./QModalVideos.vue?vue&type=style&index=0&id=452f7a6c&scoped=true&lang=scss"

import exportComponent from "/home/signal-frontend-demo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-452f7a6c"]])

export default __exports__